import { CustomDataLayer } from './wtag/datalayer';
import {
  datalayerWrapperFunc,
  WTagDataLayerBase,
} from './wtag/datalayer/datalayer_variables';

/**
 * EntryPoint is the function incharge for :
 * - creating/ binding the datalayer
 * - initializing the application
 *  Creates two variables if they don't exist:
 * - window[datalayer] : the datalayer array
 * - window[datalayerWrapperFunc] : the function to push data into the datalayer
 */
export default function EntryPoint() {
  const datalayer = WTagDataLayerBase;
  (window as any)[datalayer] = (window as any)[datalayer] || ([] as unknown[]);
  Object.setPrototypeOf((window as any)[datalayer], new CustomDataLayer());

  // If Not defined
  if ((window as any)[datalayerWrapperFunc] === undefined) {
    (window as any)[datalayerWrapperFunc] = function (...args: unknown[]) {
      return ((window as any)[datalayer] as unknown[]).push(args);
    };
  }
}
